import { Response, CopilotHistory, CopilotConfig } from "@/types"

import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import type { FileUploadResponse } from "./file-upload"

interface HistoryResponse {
  id: number
  name: string
  created_at: string
  updated_at: string
}

export const historyResponseToCopilotHistory = (
  resp: HistoryResponse
): CopilotHistory => {
  return {
    id: resp.id.toString(),
    name: resp.name,
    createdAt: resp.created_at,
    updatedAt: resp.updated_at,
  }
}

export const useGetCopilotHistoriesApi = () => {
  return useCodeerApi<Response<HistoryResponse[]>>(
    "/copilot/histories",
    FetchMethod.Get
  )
}

interface ConfigResponse {
  suggestion_questions?: string[]
  suggestion_questions_by_page?: Record<string, string[]>
}

export const configResponseToCopilotConfig = (
  resp: ConfigResponse
): CopilotConfig => {
  return {
    suggestionQuestions: resp.suggestion_questions,
    suggestionQuestionsByPage: resp.suggestion_questions_by_page,
  }
}

export const useGetCopilotConfigApi = () => {
  return useCodeerApi<Response<ConfigResponse>>(
    "/copilot/config",
    FetchMethod.Get
  )
}

export const useUploadCopilotFileApi = () => {
  return useCodeerApi<Response<FileUploadResponse>, FormData>(
    "/copilot/upload-file",
    FetchMethod.Post
  )
}
